import React, { useState } from "react";
import { FindMore } from "../../../../common/FindMore";
import { mergeCssClass } from "../../../../utils/helpers";

import "./Visualisation.css";

const getImgCssClass = (isSelected) => {
  return mergeCssClass(
    "visualisation-container__img-container__img",
    isSelected && "visualisation-container__img-container__img--selected"
  );
};

const getImgContainer = (isImg2Selected) => {
  return mergeCssClass(
    "visualisation-container__img-container",
    isImg2Selected && "visualisation-container__img-container--move-left"
  );
};

export const Visualisation = () => {
  const [selected, setSelected] = useState(1);

  return (
    <div className="visualisation-container">
      <div className={getImgContainer(selected === 2)}>
        <img
          src="/img/visualisation1.jpg"
          className={getImgCssClass(selected === 1)}
          onClick={() => setSelected(1)}
        />
        <img
          src="/img/visualisation2.jpg"
          className={getImgCssClass(selected === 2)}
          onClick={() => setSelected(2)}
        />
      </div>
      <div className="services-body visualisation-container__details-container">
        <div className="visualisation-container__details">
          <h2 className="visualisation-container__details__title">
            VISUALIZATIONS
          </h2>
          <p className="visualisation-container__details__content">
            We create CG ART visualizations for residential and commercial
            interiors. 3D renderings are a photorealistic way of understanding
            an architectural plan, a construction drawing or something that does
            not exist yet, an idea or a concept.
            <br />
            <br />
            Therefore, if you are looking to outsource a CG ART visualization
            for a client presentation or marketing purposes we are the team to
            partner with.
          </p>
          <FindMore
            text="SEE VISUALIZATIONS PORTFOLIO"
            path="/visualisation"
            className="visualisation-container__details__see-more"
          />
        </div>
      </div>
    </div>
  );
};
